import cx from "classnames";
import moment from "moment";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import { useAppService } from "../hooks/use-app-service";
import { history } from "../_config";
import { getGroupPageRoute } from "../_pages";
import {
  NotificationPage,
  NOTIFICATION_PAGE_ROUTE,
} from "../_pages/notification.page";
import { createPostDetailPageRouteFromSlug } from "../_pages/post-detail.page";
import { createUserWallPageRoute } from "../_pages/user-wall.page";
import { NotificationService } from "../_service/notification.service";
import { setNotifications } from "../_store/_actions/notification.actions";
import I18 from "./atoms/i18";
import IconButton2 from "./icon-button-2-component";
import IconButton from "./icon-button.component";
import { Loader } from "./loader.component";
import RightSideModal from "./right-side-modal.component";

function NotificationQuickViewComponent({
  user,
  notifications,
  setNotifications,
  addToast,
}) {
  const { analyticsService } = useAppService();
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isMenuVisible, setIsMenuVisible] = useState(false);

  // TODO: handle this with redux later
  const [isLoading, setIsLoading] = useState(false);

  // Display notifications in side bar pop-up
  const [active, setActive] = useState(false);

  // update a notification in state
  const updateNotification = (notification) => {
    const oldNotifications = [...notifications];
    const index = oldNotifications.findIndex((n) => n.id === notification.id);

    if (index > -1) {
      oldNotifications.splice(index, 1, notification);
      setNotifications(oldNotifications);
    }
  };

  const unreadNotificationCount = notifications.filter(
    (n) => !n.isReceived
  ).length;
  const actualUnreadNotificationCount = notifications.filter(
    (n) => !n.isViewed
  ).length;

  // hide on clicking outside this
  useEffect(() => {
    if (!isDropdownVisible) {
      return;
    }

    const closeMenuListener = (e) => {
      setIsDropdownVisible(false);
    };

    window.document.body.addEventListener("click", closeMenuListener);

    return () => {
      window.document.body.removeEventListener("click", closeMenuListener);
    };
  }, [isDropdownVisible]);

  return (
    <div
      className="NotificationQuickView"
      onClick={(e) => {
        e.stopPropagation();
      }}>
      {/* notification icon */}
      <div
        onClick={(e) => {
          setActive(!active);
          //mix panel event
          analyticsService.track("see-notification", {
            notificationCount: notifications?.length,
          });
          // send to notication page for now
          // history.push(NOTIFICATION_PAGE_ROUTE);
          // setIsDropdownVisible(!isDropdownVisible);
        }}
        className="notification-button-holder flex-row  flex items-center">
        <IconButton2 icon="bell" />
        <div className="sm:hidden">
          <I18>Notifications</I18>
        </div>
        {/* unread notification count */}
        {unreadNotificationCount > 0 ? (
          <div
            className="notification-unread-count cursor-pointer"
            onClick={(e) => {
              // setIsDropdownVisible(!isDropdownVisible);
              setActive(!active);
            }}>
            <span>{unreadNotificationCount}</span>
          </div>
        ) : (
          <></>
        )}

        <>
          <RightSideModal
            width={650}
            setActive={setActive}
            active={!isDropdownVisible && active}>
            <NotificationPage setDisplayNotificationPopUp={setActive} />
          </RightSideModal>
        </>
      </div>

      {/* notification list */}
      {false && isDropdownVisible ? (
        <div className="notification-dropdown theme-bg-surface rounded pt-2 shadow">
          <div className="px-3 pb-2 flex items-center justify-between border-b theme-border-default">
            <span className="font-bold theme-text-subtitle-1">
              <I18>Notifications</I18>
            </span>
            <div className="flex items-center">
              {/* loader */}
              {isLoading ? <Loader /> : <></>}
              <IconButton
                icon="setting"
                iconSmall
                onClick={() => {
                  setIsMenuVisible(!isMenuVisible);
                }}
              />
              {/* menu */}
              <div
                className={cx(
                  "dropdown shadow-lg theme-bg-surface my-2 py-2 rounded",
                  {
                    visible: isMenuVisible,
                    hidden: !isMenuVisible,
                  }
                )}
                onMouseLeave={(e) => {
                  setIsMenuVisible(false);
                }}
                onClick={(e) => {
                  e.stopPropagation();
                }}>
                <div
                  onClick={() => {
                    if (
                      actualUnreadNotificationCount > 0 &&
                      notifications.length > 0
                    ) {
                      setIsLoading(true);
                      NotificationService.markNotificationsAsViewed(
                        user,
                        notifications.map((n) => n.id)
                      )
                        .then(({ ids }) => {
                          setNotifications(
                            notifications.map((notification) => {
                              if (ids.includes(notification.id)) {
                                notification.isViewed = true;
                              }
                              return notification;
                            })
                          );
                          setIsLoading(false);
                        })
                        .catch((error) => {
                          setIsLoading(false);
                          console.log(
                            "could not mark notifications as read/viewed",
                            { error }
                          );
                        });
                    }
                    setIsMenuVisible(false);
                  }}
                  className="dropdown-button">
                  <I18>Mark all viewed</I18>
                </div>
              </div>
            </div>
          </div>
          {/* list items */}
          <div className="notification-list-holder">
            {isLoading ? (
              <div className="flex justify-center">
                <Loader />
              </div>
            ) : notifications.length === 0 ? (
              <div className="flex justify-center">
                <I18>No notification...</I18>
              </div>
            ) : (
              <div className="flex justify-center flex-col">
                {notifications.map((notification) => (
                  <NotificationItem
                    user={user}
                    notification={notification}
                    updateNotification={updateNotification}
                    addToast={addToast}
                    key={notification.id}
                    closeDropDown={(e) => {
                      setActive(false);
                      setIsDropdownVisible(false);
                    }}
                  />
                ))}
              </div>
            )}
          </div>
          {/* show all - button */}
          <div
            className="show-more px-3 py-2 cursor-pointer text-center border-t theme-border-default text-xs"
            onClick={(e) => {
              // hide dropdown
              history.push(NOTIFICATION_PAGE_ROUTE);
              setIsDropdownVisible(false);
            }}>
            <I18>Show more</I18>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

export function NotificationItem({
  user,
  notification,
  addToast,
  updateNotification = (notification) => {},
  closeDropDown = (e) => {},
}) {
  const { analyticsService } = useAppService();

  const markNotificationAsRead = async (id) => {
    return NotificationService.markNotificationAsRead(user, id)
      .then(() => {
        // update the notification as viewed
        updateNotification({ ...notification, isViewed: true });
      })
      .catch((error) => {
        // could not mark notification as viewed
        console.log({ message: "Could not mark notification as read!", error });
      });
  };

  return (
    <div
      className={cx(
        "NotificationItem px-3 pt-4 cursor-pointer flex border-b theme-border-default",
        {
          "theme-bg-primary-light hover:theme-bg-default":
            !notification.isViewed,
          "hover:theme-bg-primary-light": notification.isViewed,
        }
      )}
      onClick={async (e) => {
        // close dropdown
        //mix panel event

        analyticsService.track("notification-clicked", {
          notificationType: notification?.type,
        });
        // mark it as viewed
        await markNotificationAsRead(notification.id);

        if (["follow", "group:user-joined"].includes(notification.type)) {
          // open user profile
          return history.push(
            createUserWallPageRoute(notification.from.id, "posts")
          );
        }
        if (
          [
            "group:user-requested",
            "group:user-joined",
            "group:request-accepted",
          ].includes(notification.type)
        ) {
          // open the group page
          return history.push(getGroupPageRoute(notification.group.id));
        }

        // if notification has post , show the post detail page
        if (notification.post) {
          history.push(createPostDetailPageRouteFromSlug(notification.post));
          console.log(
            "Open Post",
            createPostDetailPageRouteFromSlug(notification.post)
          );
          return;
        } else if (
          ["post-like", "post-create", "post-comment", "comment-reply"] &&
          !notification.post
        ) {
          addToast(
            "Post not found",
            "May be it has been deleted by author",
            ToastTypes.info
          );
          return;
        }
        // show toast
        return addToast("Yet to be implemented!", "", ToastTypes.info);
      }}>
      {/* user avatar */}
      <div className="flex">
        <div
          style={{
            backgroundImage: "url('" + notification.from.picture + "')",
            width: "36px",
            height: "36px",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            borderRadius: "50%",
            marginRight: "12px",
            flexShrink: 0,
          }}></div>
      </div>
      <div className="flex flex-col flex-grow">
        <div
          className={cx("subtitle-1-text-color mb-2", {
            "font-semibold": !notification.isViewed,
          })}>
          {notification.title}
        </div>
        <div className="text-right text-xs subtitle-2-text-color">
          {moment(notification.createdAt).fromNow()}
        </div>
      </div>
    </div>
  );
}

export const NotificationQuickView = withToast(
  connect(
    (s) => ({ user: s.auth, notifications: s.notifications }),
    (d) => bindActionCreators({ setNotifications: setNotifications }, d)
  )(NotificationQuickViewComponent)
);
